import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div className="card">
      <h2 className="card-title">Page Not Found</h2>
      <p>The page you are looking for does not exist or has been moved.</p>
      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <Link to="/" className="btn">
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;